<template>
    <Header></Header>
    <Left></Left>
    <section class="container">
        <div>
            <div class="area_title">
                <p>내담자 검색</p>
                <div class="area_button">
                    <button type="button" @click="router.push({ name: 'client' })" class="type1">
                        <span>전체보기</span>
                    </button>
                </div>
            </div>
            <div class="area_body">
                <div class="area_section">
                    <div class="area_table">
                        <div class="area_table_body">
                            <DataGrid
                                :list="clientPageState.list"
                                :columns="clientPageState.fields"
                                :totalLength="clientPageState.length"
                                :perPage="clientPageState.perPage"
                                :isLoading="clientPageState.isLoading"
                                @onRowClick="fnRowClick"
                            ></DataGrid>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="container" v-if="user.userInfo.auth > 5">
        <div>
            <div class="area_title">
                <p>상담 기록 검색</p>
                <div class="area_button">
                    <button type="button" @click="router.push({ name: 'counsel' })" class="type1">
                        <span>전체보기</span>
                    </button>
                </div>
            </div>
            <div class="area_body">
                <div class="area_section">
                    <div class="area_table">
                        <div class="area_table_body">
                            <DataGrid
                                :list="counselPageState.list"
                                :columns="counselPageState.fields"
                                :totalLength="counselPageState.length"
                                :perPage="counselPageState.perPage"
                                :isLoading="counselPageState.isLoading"
                                @onRowClick="fnRowClick2"
                            ></DataGrid>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="container" v-else style="display: flex">
        <div style="width: 50%; margin-right: 10px">
            <div class="area_title">
                <p>잔여량이 가장 많은 물품</p>
                <div class="area_button">
                    <button type="button" @click="router.push({ name: 'item' })" class="type1">
                        <span>전체보기</span>
                    </button>
                </div>
            </div>
            <div class="area_body">
                <div class="area_section">
                    <div class="area_table">
                        <div class="area_table_body">
                            <DataGrid
                                :list="itemPageState1.list"
                                :columns="itemPageState1.fields"
                                :totalLength="itemPageState1.length"
                                :perPage="itemPageState1.perPage"
                                :isLoading="itemPageState1.isLoading"
                                @onRowClick="fnRowClick3"
                            ></DataGrid>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="width: 50%; margin-left: 10px">
            <div class="area_title">
                <p>가장 최근에 입고된 물품</p>
                <div class="area_button">
                    <button type="button" @click="router.push({ name: 'item' })" class="type1">
                        <span>전체보기</span>
                    </button>
                </div>
            </div>
            <div class="area_body">
                <div class="area_section">
                    <div class="area_table">
                        <div class="area_table_body">
                            <DataGrid
                                :list="itemPageState2.list"
                                :columns="itemPageState2.fields"
                                :totalLength="itemPageState2.length"
                                :perPage="itemPageState2.perPage"
                                :isLoading="itemPageState2.isLoading"
                                @onRowClick="fnRowClick4"
                            ></DataGrid>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>
</template>
<script lang="ts" config>
    import {
        userStore,
        globalStore,
        reactive,
        watch,
        apiService,
        onMounted,
        router,
        Header,
        Left,
        ModalDefault,
        types,
        ref,
        onBeforeUnmount,
        getMessageByCode,
        DataGrid,
        CommonUtils,
        Spinner,
    } from "@/BaseComponent";

    export default {
        props: {},
        components: { Header, Left, ModalDefault, DataGrid, Spinner },
        setup() {
            const today = new Date();
            const user = userStore();

            const state = reactive({
                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,
            });

            const clientPageState = reactive({
                perPage: 10,
                cntPage: 5,
                currentPage: 1,
                list: [] as any,
                length: 0 as number,
                isLoading: false,
                fields: [
                    { key: "idx", label: "IDX", class: "text-center" },
                    {
                        key: "number",
                        label: "연번",
                        clickable: true,
                        class: "text-left",
                    },

                    {
                        key: "name",
                        label: "이름",
                        clickable: false,
                        class: "text-center",
                    },

                    {
                        key: "clientDetailVO.phone",
                        label: "전화번호",
                        clickable: false,
                        class: "text-center",
                        render: (row: any) => {
                            if (row.clientDetailVO) return CommonUtils.convertPhoneNum(row.clientDetailVO.phone);
                            return "";
                        },
                    },

                    {
                        key: "clientDetailVO.birth",
                        label: "생년월일",
                        clickable: false,
                        class: "text-center",
                        render: (row: any) => {
                            if (row.clientDetailVO) return CommonUtils.dateFormatYYYYMMDD(row.clientDetailVO.birth, ".");
                            return "";
                        },
                    },

                    {
                        key: "cntCounsel",
                        label: "상담건 수",
                        class: "text-center",
                        render: (row: any) => {
                            if (row.cntCounsel > 0) return CommonUtils.numberFormat(row.cntCounsel);
                            return 0;
                        },
                    },
                    {
                        key: "consultDepartment",
                        label: "상담부서",
                        class: "text-center",
                    },
                    {
                        key: "counselor",
                        label: "담당상담원",
                        class: "text-center",
                    },
                    {
                        key: "state",
                        label: "진행상황",
                        class: "text-center",
                        render: (row: any) => {
                            let strResult = "";
                            switch (row.state) {
                                case 0:
                                    strResult = "데이터 없음";
                                    break;
                                case 1:
                                    strResult = "진행";
                                    break;
                                case 2:
                                    strResult = "종결";
                                    break;
                                case 3:
                                    strResult = "보류";
                                    break;
                                case 4:
                                    strResult = "비해당";
                                    break;
                                default:
                                    strResult = "데이터 없음";
                                    break;
                            }
                            if (row.state === 1 && row.stateSub && row.stateSub !== "" && row.stateSub !== "-") {
                                strResult += ` (${row.stateSub})`;
                            }
                            return strResult;
                        },
                    },
                    {
                        key: "counselType",
                        label: "상담유형",
                        class: "text-center",
                        render: (row: any) => {
                            let strResult = "";
                            switch (row.counselType) {
                                case 1:
                                    strResult = "전화상담";
                                    break;
                                case 2:
                                    strResult = "내방상담";
                                    break;
                                case 3:
                                    strResult = "방문상담";
                                    break;
                                case 4:
                                    strResult = "사이버";
                                    break;
                                case 5:
                                    strResult = "아웃리치";
                                    break;
                                case 6:
                                    strResult = "현장상담";
                                    break;
                                default:
                                    strResult = "데이터 없음";
                                    break;
                            }
                            return strResult;
                        },
                    },

                    {
                        key: "state",
                        label: "승인 상태",
                        class: "text-center",
                        render: (row: any) => {
                            let strResult = "";
                            switch (row.isCheck) {
                                case 0:
                                    strResult = "대기";
                                    break;
                                case 1:
                                    strResult = "승인";

                                    // if (row.commentForTeamLeader && row.commentForTeamLeader) {
                                    //     strResult += `(O)`;
                                    // }
                                    break;
                                case 2:
                                    strResult = "보완 요청";
                                    break;
                            }
                            return strResult;
                        },
                    },
                ],
            });

            const counselPageState = reactive({
                perPage: 5,
                cntPage: 5,
                currentPage: 1,
                list: [] as any,
                length: 0 as number,
                isLoading: false,
                fields: [
                    {
                        key: "date",
                        label: "작성일",
                        class: "text-center",
                        render: (row: any) => {
                            return CommonUtils.dateFormatYYYYMMDD(row.date, ".");
                        },
                    },
                    {
                        key: "clientVO.number",
                        label: "연번",
                        clickable: true,
                        class: "text-left",
                    },
                    {
                        key: "clientVO.name",
                        label: "이름",
                        clickable: false,
                        class: "text-center",
                    },

                    {
                        key: "clientVO.clientDetailVO.phone",
                        label: "전화번호",
                        clickable: false,
                        class: "text-center",
                        render: (row: any) => {
                            if (row.clientVO) return CommonUtils.convertPhoneNum(row.clientVO.clientDetailVO.phone);
                            return "";
                        },
                    },

                    {
                        key: "clientVO.clientDetailVO.birth",
                        label: "생년월일",
                        clickable: false,
                        class: "text-center",
                        render: (row: any) => {
                            if (row.clientVO) return CommonUtils.dateFormatYYYYMMDD(row.clientVO.clientDetailVO.birth, ".");
                            return "";
                        },
                    },
                    { key: "consultDepartmentF", label: "상담부서", class: "text-center" },
                    { key: "title", label: "제목", class: "text-left", clickable: true },
                    { key: "cstype", label: "상담유형", class: "text-center" },
                    { key: "csmName", label: "작성자", class: "text-center" },
                    {
                        key: "state",
                        label: "진행상황",
                        class: "text-center",
                        render: (row: any) => {
                            let strResult = "";
                            switch (row.clientVO.state) {
                                case 0:
                                    strResult = "데이터없음";
                                    break;
                                case 1:
                                    strResult = "진행";
                                    break;
                                case 2:
                                    strResult = "종결";
                                    break;
                                case 3:
                                    strResult = "보류";
                                    break;
                                case 4:
                                    strResult = "비해당";
                                    break;
                            }
                            if (row.clientVO.state === 1 && row.clientVO.stateSub && row.clientVO.stateSub !== "" && row.clientVO.stateSub !== "-") {
                                strResult += ` (${row.clientVO.stateSub})`;
                            }
                            return strResult;
                        },
                    },
                    {
                        key: "newSuccessState",
                        label: "성과현황",
                        class: "text-center",
                        render: (row: any) => {
                            let strResult = "";
                            switch (row.newSuccessState) {
                                case 0:
                                    strResult = "없음";
                                    break;
                                case 1:
                                    strResult = "있음";
                                    break;
                            }
                            return strResult;
                        },
                    },
                    { key: "result", label: "조치결과", class: "text-center" },
                    {
                        key: "state",
                        label: "승인 상태",
                        class: "text-center",
                        render: (row: any) => {
                            let strResult = "";
                            switch (row.state) {
                                case 0:
                                    strResult = "대기";
                                    break;
                                case 1:
                                    strResult = "승인";

                                    if (row.counselDetailVO && row.counselDetailVO.opinion) {
                                        strResult += `(O)`;
                                    }
                                    break;
                                case 2:
                                    strResult = "보완 요청";
                                    break;
                            }
                            return strResult;
                        },
                    },
                ],
            });

            const itemPageState1 = reactive({
                perPage: 10,
                cntPage: 5,
                currentPage: 1,
                list: [] as any,
                length: 0 as number,
                isLoading: false,
                fields: [
                    { key: "idx", label: "No.", class: "text-center" },
                    { key: "name", label: "물품명", class: "text-center", clickable: true },
                    {
                        key: "file",
                        label: "썸네일",
                        class: "text-center",
                        clickable: true,
                        render: (row: any) => {
                            if (row.file) return `<span class='table_thumbnail'><img src = "${row.file}"/></span>`;

                            return `<span class='table_thumbnail'><img src = "img/no_img.png"/></span>`;
                        },
                    },
                    { key: "cnt", label: "수량", class: "text-center" },
                    { key: "team", label: "부서", class: "text-center" },
                    { key: "writer", label: "등록자", class: "text-center" },
                    // {
                    //     key: "createDate",
                    //     label: "등록일",
                    //     class: "text-center",
                    //     render: (row: any) => {
                    //         return CommonUtils.dateFormat(row.createDate, ".", true);
                    //     },
                    // },
                    {
                        key: "recentEntireDate",
                        label: "최근 입고일",
                        class: "text-center",
                        render: (row: any) => {
                            return CommonUtils.dateFormat(row.recentEntireDate, ".", true);
                        },
                    },
                ],
            });

            const itemPageState2 = reactive({
                perPage: 10,
                cntPage: 5,
                currentPage: 1,
                list: [] as any,
                length: 0 as number,
                isLoading: false,
                fields: [
                    { key: "idx", label: "No.", class: "text-center" },
                    { key: "name", label: "물품명", class: "text-center", clickable: true },
                    {
                        key: "file",
                        label: "썸네일",
                        class: "text-center",
                        clickable: true,
                        render: (row: any) => {
                            if (row.file) return `<span class='table_thumbnail'><img src = "${row.file}"/></span>`;

                            return `<span class='table_thumbnail'><img src = "img/no_img.png"/></span>`;
                        },
                    },
                    { key: "cnt", label: "수량", class: "text-center" },
                    { key: "team", label: "부서", class: "text-center" },
                    { key: "writer", label: "등록자", class: "text-center" },
                    // {
                    //     key: "createDate",
                    //     label: "등록일",
                    //     class: "text-center",
                    //     render: (row: any) => {
                    //         return CommonUtils.dateFormat(row.createDate, ".", true);
                    //     },
                    // },
                    {
                        key: "recentEntireDate",
                        label: "최근 입고일",
                        class: "text-center",
                        render: (row: any) => {
                            return CommonUtils.dateFormat(row.recentEntireDate, ".", true);
                        },
                    },
                ],
            });

            onMounted(() => {
                me();

                clientFnGetList();
            });

            const me = async () => {
                const res = await apiService.base.me();

                if (res.returnCode === 0) {
                    user.setInfo(res.data);
                    if (user.userInfo.auth > 5) counselFnGetList();
                    else {
                        getItemForMain1();
                        getItemForMain2();
                    }
                } else {
                    console.error(res.description);
                }
            };

            const clientFnGetList = async () => {
                clientPageState.isLoading = true;
                const res: types.client.ResClientList = await apiService.client.listForMain();

                if (res.returnCode === 0 && res.data) {
                    clientPageState.list = res.data;
                    clientPageState.length = res.data.length;
                } else {
                    console.error(res.description);
                }
                clientPageState.isLoading = false;
            };

            const counselFnGetList = async () => {
                counselPageState.isLoading = true;
                const res: types.counsel.ResCounselList = await apiService.counsel.listForMain();

                if (res.returnCode === 0 && res.data) {
                    counselPageState.list = res.data;
                    counselPageState.length = res.data.length;
                } else {
                    console.error(res.description);
                }
                counselPageState.isLoading = false;
            };

            const getItemForMain1 = async () => {
                itemPageState1.isLoading = true;
                const res: types.item.ResItemList = await apiService.item.listForMain1();

                if (res.returnCode === 0 && res.data) {
                    itemPageState1.list = res.data;
                    itemPageState1.length = res.data.length;
                } else {
                    console.error(res.description);
                }
                itemPageState1.isLoading = false;
            };

            const getItemForMain2 = async () => {
                itemPageState2.isLoading = true;
                const res: types.item.ResItemList = await apiService.item.listForMain2();

                if (res.returnCode === 0 && res.data) {
                    itemPageState2.list = res.data;
                    itemPageState2.length = res.data.length;
                } else {
                    console.error(res.description);
                }
                itemPageState2.isLoading = false;
            };

            const closeModal = () => {
                state.isShowModal = false;
            };

            const callBackModal = async (param: any) => {};

            const fnRowClick = (row: any, col: any) => {
                if (col.key === "number") {
                    if (user.userInfo.auth > 5) {
                        if (
                            row.consultDepartment !== user.userInfo.team &&
                            user.userInfo.auth < 8 &&
                            !(user.userInfo.auth === 5 && row.consultDepartment === "기타")
                        ) {
                            state.modalTab = -1;
                            state.modalTitle = "알림";
                            state.modalContent = "접근 권한이 없습니다.";
                            state.isShowModal = true;
                            return;
                        }
                        router.push({ name: "clientDetail", params: { id: row.idx } });
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = "접근 권한이 없습니다.";
                        state.isShowModal = true;
                        return;
                    }
                }
            };

            const fnRowClick2 = (row: any, col: any) => {
                if (col.key === "title") {
                    if (user.userInfo.auth > 5) {
                        if (row.consultDepartmentF !== user.userInfo.team && user.userInfo.auth < 8) {
                            state.modalTab = -1;
                            state.modalTitle = "알림";
                            state.modalContent = "접근 권한이 없습니다.";
                            state.isShowModal = true;
                            return;
                        }
                        router.push({ name: "counselDetail", params: { id: row.clIdx, idx: row.coIdx } });
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = "접근 권한이 없습니다.";
                        state.isShowModal = true;
                        return;
                    }
                } else if (col.key === "clientVO.number") {
                    if (user.userInfo.auth > 5) {
                        router.push({ name: "counselListForClient", params: { id: row.clIdx } });
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = "접근 권한이 없습니다.";
                        state.isShowModal = true;
                        return;
                    }
                }
            };

            const fnRowClick3 = (row: any, col: any) => {
                if (col.key === "name") router.push({ name: "itemHistory", params: { id: row.idx } });
                else if (col.key === "file") viewImage(row.file);
            };

            const fnRowClick4 = (row: any, col: any) => {
                if (col.key === "name") router.push({ name: "itemHistory", params: { id: row.idx } });
                else if (col.key === "file") viewImage(row.file);
            };

            const viewImage = async (param: string) => {
                state.modalTab = 4;
                state.modalTitle = "알림";
                state.modalContent = param;
                state.isShowModal = true;
            };

            return {
                state,
                closeModal,
                callBackModal,
                router,
                clientPageState,
                counselPageState,
                fnRowClick,
                fnRowClick2,
                user,
                itemPageState1,
                itemPageState2,
                fnRowClick3,
                fnRowClick4,
            };
        },
    };
</script>
